import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { get_generic, put_generic } from "../../../services/http_operations";
import { ReplaceUnderscores } from "../../../services/misc_functions";

export default function ViewKPIPage() {
  //state definitions
  const [thingNames, setThingNames] = useState(null);
  const [deviceNames, setDeviceNames] = useState(null);
  const [devices, setDevices] = useState(null);
  const [features, setFeatures] = useState(null);
  const [tableRows, setTableRows] = useState(null);

  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedThing, setSelectedThing] = useState(null);

  //message for user
  useEffect(() => {
    const fetchdata = async () => {
      const thingsRes = await get_generic("things", {
        limit: -1,
      });
      const things = thingsRes.docs.map((t) => t._id).reverse();

      const devicesRes = await get_generic("devices", {
        limit: -1,
        select: ["_id", "features", "tags"],
      });
      const featureRes = await get_generic("features", {
        limit: -1,
        select: ["_id", "description", "items"],
      });

      const _deviceNames = devicesRes.docs.map((d) => d._id).reverse();
      setDeviceNames(_deviceNames);
      setDevices(devicesRes.docs);
      setThingNames(things);
      setFeatures(featureRes.docs);
    };
    fetchdata();
  }, []);

  //callbacks
  const handleSelectChange = async (thing) => {
    setSelectedThing(thing);
    refreshTableRows(thing);
  };

  const refreshTableRows = async (thing) => {
    const measurementsRes = await get_generic("measurements", {
      limit: -1,
      filter: JSON.stringify({
        thing: thing,
      }),
    });
    const measurements = measurementsRes.docs;

    const _tableRows = [];
    measurements
      .filter((m) => !m.feature.includes("_description"))
      .forEach((m) => {
        const _feature = features.find((f) => f._id === m.feature);
        const descMeasure = measurements.find(
          (d) => d.feature === m.feature + "_description"
        );

        const _rows = m.samples[0].values.map((v, i) => {
          return {
            thing: m.thing,
            device: ReplaceUnderscores(m.device),
            techRQs: _feature.description,
            techKpi: ReplaceUnderscores(_feature.items[i].name),
            techLoggingReqs: _feature.items[i].description,
            kpiIndex: m.feature.split("_")[1],
            kpiSubIndex: i,
            kpiValue: v,
            kpiDescription: descMeasure.samples[0].values[i],
            id: m._id,
            descId: descMeasure._id,
          };
        });
        _tableRows.push(_rows);
      });
    setTableRows(_tableRows.reverse().flat());
  };

  const handleDeconsolidate = async (id, descId) => {
    const confirm = window.confirm(
      "Are you sure you want to send this KPI back to the stage?"
    );
    if (confirm === false) return;
    else {
      await put_generic("measurements/", { stage: "draft" }, id);
      await put_generic("measurements/", { stage: "draft" }, descId);
      refreshTableRows(selectedThing);
    }
  };

  return (
    <div className="page">
      <header className="page-header">View KPIs</header>
      <main className="page-content">
        <Container fluid>
          <Row style={{ paddingBottom: 5 + "px" }}>
            <Col sm={3}>
              {deviceNames !== null ? (
                <Form.Group className="mb-3">
                  <Form.Select
                    onChange={(e) => {
                      e.preventDefault();
                      setSelectedDevice(e.target.value);
                    }}
                  >
                    <option>Select Group</option>
                    <option>All</option>
                    {React.Children.toArray(
                      deviceNames.map((e) => {
                        return (
                          <option value={e}>{ReplaceUnderscores(e)}</option>
                        );
                      })
                    )}
                  </Form.Select>
                </Form.Group>
              ) : (
                "Loading"
              )}
            </Col>
            <Col sm={3}>
              {thingNames !== null ? (
                <Form.Group className="mb-3">
                  <Form.Select
                    disabled={selectedDevice === null}
                    onChange={(e) => {
                      e.preventDefault();
                      handleSelectChange(e.target.value);
                    }}
                  >
                    <option>Select Enabler</option>
                    {React.Children.toArray(
                      thingNames
                        .filter((t) =>
                          selectedDevice !== null &&
                          selectedDevice !== "All" &&
                          selectedDevice !== "Select Group"
                            ? devices
                                .find((d) => d._id === selectedDevice)
                                .tags.includes(t)
                            : true
                        )
                        .map((e) => {
                          return (
                            <option value={e}>{ReplaceUnderscores(e)}</option>
                          );
                        })
                    )}
                  </Form.Select>
                </Form.Group>
              ) : (
                "Loading"
              )}
            </Col>
          </Row>
          {tableRows !== null ? (
            <KpiTable
              tableRows={tableRows}
              handleDeconsolidate={handleDeconsolidate}
            />
          ) : (
            <Row>
              <hr />
              <Col>Select Enabler to show its KPIs</Col>
            </Row>
          )}
        </Container>
      </main>
    </div>
  );
}

function KpiTable({ tableRows, handleDeconsolidate }) {
  if (tableRows.length === 0)
    return (
      <Row>
        <Col sm={3}>There are no consolidated KPI for the selected Enabler</Col>
      </Row>
    );

  return (
    <React.Fragment>
      <Row style={{ paddingTop: 20 + "px" }}>
        <Col>
          Consolidated KPI by Enabler
          <b> {tableRows[0].thing}</b>
        </Col>
      </Row>
      <Row style={{ paddingTop: 20 + "px" }}>
        <Col sm={12}>
          <div
            style={{
              height: 30 + "vh",
              minHeight: 300 + "px",
              width: 100 + "%",
              overflow: "scroll",
            }}
          >
            <Table striped bordered hover size="lg">
              <thead>
                <tr>
                  <th style={{ width: "10%" }}>Group</th>
                  <th style={{ width: "20%" }}>Tech RQs</th>
                  <th style={{ width: "20%" }}>Tech Logging Requirements</th>
                  <th style={{ width: "10%" }}>ID - Tech KPIs</th>
                  <th style={{ width: "5%" }}>KPI's Value</th>
                  <th style={{ width: "7%" }}>KPI's Personal Description</th>
                  <th style={{ width: "5%" }}>Deconsolidate KPI</th>
                </tr>
              </thead>
              <tbody>
                {React.Children.toArray(
                  tableRows.map((r, i) => {
                    return (
                      <tr>
                        <td>
                          {i !== 0 && r.id === tableRows[i - 1].id
                            ? " "
                            : ReplaceUnderscores(r.device)}
                        </td>
                        <td>
                          {i !== 0 && r.id === tableRows[i - 1].id
                            ? " "
                            : r.techRQs}
                        </td>
                        <td>
                          {i !== 0 && r.id === tableRows[i - 1].id
                            ? " "
                            : r.techLoggingReqs}
                        </td>
                        <td>
                          {r.kpiIndex} [{r.kpiSubIndex}] -{" "}
                          {ReplaceUnderscores(r.techKpi)}
                        </td>
                        <td>{r.kpiValue}</td>
                        <td>{r.kpiDescription}</td>
                        <td>
                          {i !== 0 && r.id === tableRows[i - 1].id ? (
                            " "
                          ) : (
                            <OverlayTrigger
                              overlay={
                                <Tooltip id="edit">
                                  {"Send KPI back to stage"}
                                </Tooltip>
                              }
                              placement="top"
                              delayShow={300}
                              delayHide={150}
                            >
                              <Button
                                variant="outline-warning"
                                style={{
                                  pointerEvents: "all",
                                  border: "none",
                                  width: 50 + "px",
                                  height: 40 + "px",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDeconsolidate(r.id, r.descId);
                                }}
                              >
                                <i
                                  key={"icon"}
                                  className="fa fa-share-from-square"
                                  aria-hidden="true"
                                  style={{
                                    width: 30 + "px",
                                    height: 30 + "px",
                                    opacity: 0.85,
                                  }}
                                />
                              </Button>
                            </OverlayTrigger>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}
